import classNames from '@utils/classnames';

export interface ControlStateOptions {
  isInvalid?: boolean;
  isDisabled?: boolean;
  /** Use for controls that manage focus on a child (e.g. a wrapper around an `<input>`). */
  focusWithin?: boolean;
}

/**
 * Shared shell for every form control (Input, Select, Combobox, TextArea, …):
 * 36px high, white surface, one border colour, radius 6. Focus is brand
 * orange, invalid is red — never a second accent colour.
 */
export function controlClassName(options: ControlStateOptions = {}) {
  const { isInvalid, isDisabled, focusWithin = true } = options;

  return classNames(
    'w-full h-9 rounded-md border bg-surface text-sm text-fg transition-colors outline-hidden',
    isDisabled ? 'bg-surface-sunken text-fg-muted cursor-default' : null,
    isInvalid ? 'border-negative' : 'border-border',
    !isInvalid && !isDisabled && (focusWithin ? 'focus-within:border-brand' : 'focus:border-brand'),
  );
}

/** Dropdown / popover panel used by Select, Combobox, menus. */
export const popoverPanelClassName =
  'z-dropdown overflow-auto rounded-md border border-border bg-surface py-1 text-sm text-fg shadow-md';

/** A single option row inside a dropdown panel. */
export const popoverItemClassName =
  'relative mx-1 flex cursor-pointer select-none items-center rounded py-1.5 pl-2.5 pr-8 outline-hidden hover:bg-surface-hover focus:bg-surface-hover data-highlighted:bg-surface-hover';
